import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyDrEjaia282cx9YN5TDApXu0hLMXLwobc8",
    authDomain: "todo-application-49718.firebaseapp.com",
    databaseURL: "https://todo-application-49718.firebaseio.com",
    projectId: "todo-application-49718",
    storageBucket: "",
    messagingSenderId: "581917405073",
    appId: "1:581917405073:web:7b560e87f6be7c0efe3430"
}
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js